import { Link } from 'react-router';

interface ScanModeCardProps {
  title: string;
  subtitle: string;
  redirection: string;
}

export const ScanModeCard = ({
  title,
  subtitle,
  redirection,
}: ScanModeCardProps) => {
  return (
    <Link
      to={redirection}
      className="flex w-full cursor-pointer flex-col gap-y-2 rounded-[20px] bg-white px-12 py-4 text-center hover:shadow-sm"
    >
      <h2 className="text-primary text-lg font-bold">{title}</h2>
      <p className="text-gray-400">{subtitle}</p>
    </Link>
  );
};
